import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as LogoActions from '../actions/logo.actions';

import { LogoState } from '@store/entities';
import { Logo } from '@core/models';

export const logoAdapter: EntityAdapter<Logo> = createEntityAdapter<Logo>({
  selectId: logo => logo.idLogo,
});

export const initialState: LogoState = logoAdapter.getInitialState({
  selectedLogoId: null,
  isLoading: false,
  error: null,
});

export const logoReducer = createReducer<LogoState>(
  initialState,
  on(LogoActions.getLogo, (state, { idLogo }) => ({
    ...state,
    selectedLogoId: idLogo,
    isLoading: true,
  })),
  on(LogoActions.getLogoSuccess, (state, { logo }) => {
    return logoAdapter.addOne(logo, { ...state, isLoading: false });
  }),
  on(LogoActions.getLogoFailure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  })),
  on(LogoActions.clearLogo, () => initialState)
);
